import React from 'react';

var SvgProductUnavailableIcon = function SvgProductUnavailableIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.276 3.5c-1.02 0-1.994.415-2.701 1.149l-4.254 4.417c-1.04 1.08-1.023 2.792.036 3.852l2.898 2.898c.964.963 2.52.978 3.502.033l.45-.434c.3-.287.308-.762.02-1.06-.287-.299-.761-.308-1.06-.02l-.45.434c-.393.378-1.016.372-1.401-.014l-2.898-2.898c-.482-.481-.489-1.26-.016-1.75l4.253-4.418c.424-.44 1.01-.689 1.62-.689h1.975c.966 0 1.75.784 1.75 1.75v2.371c0 .358-.146.7-.403.948-.298.287-.307.762-.02 1.06.287.299.762.308 1.06.02.552-.53.863-1.262.863-2.028v-2.371c0-1.795-1.455-3.25-3.25-3.25h-1.974Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.359 12.47c.293.293.293.768 0 1.06l-.884.884.884.884c.293.293.293.768 0 1.06-.293.294-.768.294-1.061 0l-.884-.883-.884.884c-.293.293-.768.293-1.06 0-.293-.293-.293-.768 0-1.06l.883-.885-.883-.884c-.293-.293-.293-.767 0-1.06.292-.293.767-.293 1.06 0l.884.884.884-.884c.293-.293.768-.293 1.06 0Z"
  }));
};
SvgProductUnavailableIcon.displayName = "ProductUnavailableIcon";

export { SvgProductUnavailableIcon as S };
